import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined"
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMore"
import LoadingButton from "@mui/lab/LoadingButton"
import AccordionDetails from "@mui/material/AccordionDetails"
import AccordionSummary from "@mui/material/AccordionSummary"
import Typography from "@mui/material/Typography"
import { useState } from "react"

import { CenterEverythingColumn } from "../../../../../common/components/Column"
import { useSearchParamsState } from "../../../../../common/utils"
import {
  addCRMEventToCandidate,
  useScrollToTargetElementRef,
} from "../../../utils"
import { EVENT_TYPES, GLOBAL_SEARCH_URL_PARAMS } from "../../data"
import {
  AccordionDetailsContent,
  AccordionDetailsTypography,
  AccordionSummaryContent,
  StyledAccordion,
} from "./Accordions"
import CreateNoteDialog from "./CreateNoteDialog"
import { performedBySubtitle } from "./PerformedByAttribution"
import TabColumn from "./TabColumn"
import TabContentColumn from "./TabContentColumn"
import TabHeaderRow from "./TabHeaderRow"
import ActivitySkeleton from "./components/ActivitySkeleton"

export default function NotesTab({
  candidate,
  setCandidate,
  isLoading,
  readOnly = false,
}) {
  const [createNoteDialogOpen, setCreateNoteDialogOpen] = useState(false)
  const notes = candidate.crm_events
    .filter((event) => event.type === EVENT_TYPES.note)
    .slice()
    .sort((a, b) => new Date(b.created) - new Date(a.created))

  function handleCreateNoteDialogClosed(createdNote) {
    if (createdNote) {
      addCRMEventToCandidate(setCandidate, createdNote, EVENT_TYPES.note)
    }
    setCreateNoteDialogOpen(false)
  }

  return (
    <TabColumn>
      <TabHeaderRow title="Notes History">
        {readOnly ? null : (
          <LoadingButton
            variant="outlined"
            color="inherit"
            loading={isLoading}
            startIcon={<DescriptionOutlinedIcon />}
            onClick={() => setCreateNoteDialogOpen(true)}
          >
            Add Note
          </LoadingButton>
        )}
      </TabHeaderRow>
      <TabContentColumn>
        {isLoading ? (
          <ActivitySkeleton />
        ) : notes.length === 0 ? (
          <CenterEverythingColumn>
            <Typography variant="body1" color="text.secondary">
              Nothing to show here.
            </Typography>
          </CenterEverythingColumn>
        ) : (
          notes.map((note) => <Note key={note.id} note={note} />)
        )}
      </TabContentColumn>
      <CreateNoteDialog
        candidate={candidate}
        open={createNoteDialogOpen}
        onClose={handleCreateNoteDialogClosed}
      />
    </TabColumn>
  )
}

function Note({ note }) {
  const [expandedNoteID, setExpandedNoteID] = useSearchParamsState(
    GLOBAL_SEARCH_URL_PARAMS.note
  )
  const scrollRef = useScrollToTargetElementRef(
    note,
    GLOBAL_SEARCH_URL_PARAMS.note
  )

  return (
    <StyledAccordion
      key={note.id}
      expanded={note.id === parseInt(expandedNoteID)}
      onChange={(e, expanded) => setExpandedNoteID(expanded ? note.id : null)}
      ref={scrollRef}
    >
      <AccordionSummary expandIcon={<ExpandMoreOutlinedIcon />}>
        <AccordionSummaryContent
          accordionTitle={note.title}
          subtitle={performedBySubtitle(note)}
          Icon={<DescriptionOutlinedIcon />}
          dateStr={note.created}
        />
      </AccordionSummary>
      <AccordionDetails>
        <AccordionDetailsContent>
          <AccordionDetailsTypography
            sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
          >
            {note.content}
          </AccordionDetailsTypography>
        </AccordionDetailsContent>
      </AccordionDetails>
    </StyledAccordion>
  )
}
